import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';

let initialized = false;
let initializing: Promise<void> | null = null;

export async function initZxcvbn() {
  if (initialized) return;
  if (initializing) return initializing; // if already loading, reuse same promise

  initializing = (async () => {
    try {
      const pkg = await import('@zxcvbn-ts/language-common');
      zxcvbnOptions.setOptions({
        graphs: pkg.adjacencyGraphs,
        dictionary: { ...pkg.dictionary }
      });
      initialized = true;
    } catch (err) {
      console.error('Failed to load zxcvbn language package:', err);
      // fallback: you can still use zxcvbn core without extra dictionaries
    } finally {
      initializing = null;
    }
  })();

  return initializing;
}

export { zxcvbn };
